import { useEffect, useState } from 'react'

/**
 * De huidige tijd, elke minuut ververst. Voor de nu-lijn in de agenda en knoppen die pas
 * vanaf de begintijd mogen verschijnen. Vaker verversen is onrustig en zinloos.
 */
export function useNow(intervalMs = 60_000) {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    const t = window.setInterval(() => setNow(new Date()), intervalMs)
    return () => window.clearInterval(t)
  }, [intervalMs])
  return now
}
